"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SVG = styled_components_1.default.svg `
    margin: auto;
`;
const Icon = (0, styled_components_1.default)(SVG) `
    path {
        fill: ${({ isDisabled, theme }) => isDisabled ? theme.colorControlIconDisabled : theme.colorControlIcon};
    }
`;
const SearchIcon = (_a) => {
    var { disabled = false } = _a, rest = __rest(_a, ["disabled"]);
    return (react_1.default.createElement(Icon, Object.assign({}, rest, { viewBox: "0 0 16 16", width: "16px", height: "16px", isDisabled: disabled }),
        react_1.default.createElement("path", { d: "M16,14.586,10.885,9.471a6.012,6.012,0,1,0-1.414,1.414L14.586,16ZM6,10a4,4,0,1,1,4-4A4,4,0,0,1,6,10Z" })));
};
exports.SearchIcon = SearchIcon;
//# sourceMappingURL=SearchIcon.js.map